export { default as MainTitle } from "./MainTitle";
export { default as MainSubTitle } from "./MainSubTitle";
export { default as SecondTitle } from "./SecondTitle";
export { default as SecondSubTitle } from "./SecondSubTitle";
